export default __webpack_public_path__ + "static/media/1348.e3e173fb.png";